import { Injectable } from '@angular/core';
import { FilterValue } from '@shared/models/filter-value';
import { PricingService } from '@shared/services/pricing.service';

@Injectable({
  providedIn: 'root'
})
export class FilterValueService {
  constructor(private pricingService: PricingService) {
  }

  toApiValues(filterValue: FilterValue): FilterValue {
    const {
      brand_id,
      series_id,
      model_id,
      current_price_from,
      current_price_to,
      price_from,
      price_to,
      mileage_from,
      mileage_to,
      year_from,
      year_to,
      recharge_mileage_from,
      recharge_mileage_to,
      battery_capacity_from,
      battery_capacity_to,
      wheeldrive,
    } = filterValue;

    return {
      ...(brand_id && { brand_id }),
      ...(series_id && { series_id }),
      ...(model_id && { model_id }),
      ...(wheeldrive && { wheeldrive }),
      ...(current_price_from && { current_price_from: +current_price_from }),
      ...(current_price_to && { current_price_to: +current_price_to }),
      ...(price_from && { price_from: +price_from }),
      ...(price_to && { price_to: +price_to }),
      ...(mileage_from && { mileage_from: +(mileage_from / 10000).toFixed(2) }),
      ...(mileage_to && { mileage_to: +(mileage_to / 10000).toFixed(2) }),
      ...(year_from && { year_from: +year_from }),
      ...(year_to && { year_to: +year_to }),
      ...(recharge_mileage_from && { recharge_mileage_from: +recharge_mileage_from }),
      ...(recharge_mileage_to && { recharge_mileage_to: +recharge_mileage_to }),
      ...(battery_capacity_from && { battery_capacity_from: +(+battery_capacity_from).toFixed(2) }),
      ...(battery_capacity_to && { battery_capacity_to: +(+battery_capacity_to).toFixed(2) }),
    }
  }
}
